var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectAddPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    className: "MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-vubbuv",
    focusable: "false",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6.3007812 2 A 4.31 4.31 0 0 0 2 6.3007812 L 2 17.699219 A 4.31 4.31 0 0 0 6.3007812 22 L 17.699219 22 A 4.31 4.31 0 0 0 22 17.699219 L 22 6.3007812 A 4.31 4.31 0 0 0 17.699219 2 L 6.3007812 2 z M 6.3007812 4 L 17.699219 4 A 2.3 2.3 0 0 1 20 6.3007812 L 20 17.699219 A 2.3 2.3 0 0 1 17.699219 20 L 6.3007812 20 A 2.3 2.3 0 0 1 4 17.699219 L 4 6.3007812 A 2.3 2.3 0 0 1 6.3007812 4 z M 10.982422 6.40625 L 10.982422 11.189453 L 6.2539062 11.134766 L 6.2324219 13.068359 L 10.982422 13.123047 L 10.982422 17.695312 L 12.916016 17.695312 L 12.916016 13.144531 L 17.519531 13.197266 L 17.541016 11.265625 L 12.916016 11.212891 L 12.916016 6.40625 L 10.982422 6.40625 z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectAddPlus);
export default __webpack_public_path__ + "static/media/rect-add-plus.db02283fb9ae5e3bb2a79cc0f8ad3c91.svg";
export { ForwardRef as ReactComponent };